module.exports = __webpack_public_path__ + "eac2bf7761a4a122793cc94bea393a3c.ttf";